import React from 'react';
import { Disclosure } from '@headlessui/react';
import './Context.css';

export function Context({ contextArray }) {
  return (
    <section>
      <h3>Kontekstiin liittyvä osaaminen</h3>
      {contextArray.map((contextCompetency, id) => {
        return (
          <Disclosure key={id}>
            <Disclosure.Button className="disclosure-button">
              <span>{contextCompetency.context}</span>
            </Disclosure.Button>
            <Disclosure.Panel className="disclosure-panel">
              <p className="bold">Vägledaren känner till och förstår</p>
              <ul>
                {contextCompetency.tunnistaa_ja_ymmartaa.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
              <p className="bold">Vägledaren kan</p>
              <ul>
                {contextCompetency.osaa.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </Disclosure.Panel>
          </Disclosure>
        );
      })}
    </section>
  );
}
